import React from 'react'
import { useInViewOnce } from '../hooks/useInViewOnce'
import { useEffects } from '../contexts/EffectsContext'

interface ScrollRevealProps {
	children: React.ReactNode
	/** Stagger delay in ms */
	delay?: number
	className?: string
}

/**
 * Fade-up reveal when the element first scrolls into view.
 * With the 'Scroll animations' effect disabled, renders children
 * immediately visible.
 */
export const ScrollReveal: React.FC<ScrollRevealProps> = ({ children, delay = 0, className }) => {
	const { effects } = useEffects()
	const [ref, inView] = useInViewOnce<HTMLDivElement>()

	if (!effects.scrollReveal) {
		return <div className={className}>{children}</div>
	}

	return (
		<div
			ref={ref}
			className={`scroll-reveal${inView ? ' is-visible' : ''}${className ? ` ${className}` : ''}`}
			style={delay ? { transitionDelay: `${delay}ms` } : undefined}
		>
			{children}
		</div>
	)
}

export default ScrollReveal
